import config from '../../config';
import { handleErrors } from '../../js/helpers/handleErrors';
import { store } from '../../store';
import { IDwellTimeFilter } from '../data';

export function getDwellStats (
    filter: IDwellTimeFilter
) {
    let dataToSend: {
        date: {
            from: string,
            to: string
        }[],
        zones?: number[]
    } = {
        date: filter.dateRanges,
        zones: filter.zones
    }

    return fetch(config.api.dwell, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${store.getState().userStore.token}`
            },
            credentials: 'include',
            body: JSON.stringify(dataToSend)
        })
            .then(handleErrors)
            .then(res => res.json())
            .then(res => {
                return res
            })
            .catch((error: any) => {
                return null
            })
}

export default getDwellStats